<section [attr.aria-label]="'WORK_SHARE.EXTERNAL' | translate">
  <h4
    class="!mt-0 !mb-1.5 !font-base !text-xs !font-bold uppercase tracking-wide text-grey dark:text-borders-dark"
  >
    {{ "WORK_SHARE.EXTERNAL" | translate }}
  </h4>
  <app-public-work-preview
    [data]="generated ?? preview"
    [title]="title"
    [compact]="isMobile"
    [showDetails]="includeDetails && !!generated"
  />
  <fieldset class="mt-1.5 min-w-0 flex flex-col gap-1.5">
    <div>
      <mat-checkbox
        [disabled]="busy || !!settings?.revoked"
        [(ngModel)]="includeDetails"
        (ngModelChange)="prepareLink()"
        class="white-border-checkbox block text-sm"
        ><span class="block">{{
          "WORK_SHARE.INCLUDE_DETAILS" | translate
        }}</span
        ><span class="block text-xs text-grey dark:text-borders-dark">{{
          "WORK_SHARE.PUBLIC_CONSENT" | translate
        }}</span></mat-checkbox
      >
      @if (!includeDetails && comment) {
      <p class="!mt-0.5 !mb-0 pl-[44px] text-xs">
        {{ "WORK_SHARE.INTERNAL_MESSAGE_ONLY" | translate }}
      </p>
      } @if (hasNoPersonalDetails) {
      <p
        class="!mt-0.5 !mb-0 pl-[44px] text-xs italic text-grey dark:text-borders-dark"
        role="status"
      >
        {{ "WORK_SHARE.NO_PERSONAL_DETAILS" | translate }}
      </p>
      }
    </div>
    @if (settings?.revoked) {
    <p class="!m-0 text-xs">
      {{
        (settings?.canReactivate
          ? "WORK_SHARE.REVOKED_HELP"
          : "WORK_SHARE.REVOKED"
        ) | translate
      }}
    </p>
    @if (settings?.canReactivate) {
    <button
      type="button"
      class="btn btn-small self-start whitespace-nowrap"
      [disabled]="busy"
      (click)="prepareLink(0, true, true)"
    >
      {{ "WORK_SHARE.REACTIVATE" | translate }}
    </button>
    } }
    <div
      class="form !my-0 flex min-w-0 items-center rounded-lg border border-borders-light p-[3px] dark:border-borders-darker"
    >
      <div class="relative min-w-0 flex-1">
        <input
          type="text"
          readonly
          class="!mb-0 !h-[36px] !border-0 !bg-transparent !pl-[32px] !pr-1 !text-sm text-ellipsis"
          [value]="generated?.social?.url ?? ''"
          (copy)="copiedManually($event)"
          [placeholder]="
            (busy ? 'WORK_SHARE.LINK_LOADING' : 'WORK_SHARE.LINK') | translate
          "
          [attr.aria-label]="'WORK_SHARE.LINK' | translate"
        />
        <span
          aria-hidden="true"
          class="icon !left-[10px] !top-[10px] !h-[16px] !w-[16px] mask-[url(/assets/images/icons/link.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        ></span>
      </div>
      @if (!busy && !generated) {
      <button
        type="button"
        class="btn btn-small shrink-0 whitespace-nowrap"
        (click)="prepareLink(0, !!settings)"
      >
        {{ "PUBLIC_WORK.RETRY" | translate }}
      </button>
      } @else {
      <button
        type="button"
        class="btn btn-small shrink-0 whitespace-nowrap disabled:!opacity-40 disabled:!cursor-not-allowed"
        [disabled]="busy || !generated"
        [attr.aria-busy]="busy"
        (click)="share('copy')"
      >
        {{
          (isMobile ? "WORK_SHARE.COPY_SHORT" : "WORK_SHARE.COPY") | translate
        }}
      </button>
      }
    </div>
    <button
      type="button"
      class="self-end whitespace-nowrap text-sm underline"
      [disabled]="busy"
      (click)="openSharedLinks()"
    >
      {{ "WORK_SHARE.MY_LINKS" | translate }}
    </button>
    @if (isMobile) {
    <div
      class="grid gap-0.5"
      [class.grid-cols-4]="nativeShareAvailable"
      [class.grid-cols-3]="!nativeShareAvailable"
    >
      <button
        type="button"
        class="share-channel"
        [disabled]="busy || !generated"
        (click)="share('whatsapp')"
      >
        <span class="share-channel-symbol"
          ><span class="mask-[url(/assets/images/icons/chat.svg)]"></span></span
        ><span>WhatsApp</span>
      </button>
      <button
        type="button"
        class="share-channel"
        [disabled]="busy || !generated"
        (click)="share('sms')"
      >
        <span class="share-channel-symbol"
          ><span
            class="mask-[url(/assets/images/icons/communication.svg)]"
          ></span></span
        ><span>Messages</span>
      </button>
      <button
        type="button"
        class="share-channel"
        [disabled]="busy || !generated"
        (click)="share('email')"
      >
        <span class="share-channel-symbol"
          ><span class="mask-[url(/assets/images/icons/send.svg)]"></span></span
        ><span>{{ "WORK_SHARE.EMAIL" | translate }}</span>
      </button>
      @if (nativeShareAvailable) {
      <button
        type="button"
        class="share-channel"
        [disabled]="busy || !generated"
        (click)="share('native')"
      >
        <span class="share-channel-symbol"
          ><span
            class="mask-[url(/assets/images/icons/ellipsis.svg)]"
          ></span></span
        ><span>{{ "WORK_SHARE.MORE" | translate }}</span>
      </button>
      }
    </div>
    }
  </fieldset>
  <p class="!mt-1 !mb-0 min-h-[14px] text-xs" role="status" aria-live="polite">
    {{ status | translate }}
  </p>
</section>
